<template>
  <div class="content-wrapper">
    <Loading v-if="!loadStatus" text="Loading..." />
    <template v-if="loadStatus && !Object.keys(shopDetails).length">
      <!-- create store component -->
    </template>
    <template v-if="loadStatus">
      <h2 class="page-titles">E-commerce</h2>

      <div class="tabs">
        <div class="tab">
          <label for="tab-1">Setting</label>
          <input id="tab-1" name="tabs-two" type="radio" checked="checked" />
          <div class="tab-content">
            <StoreSetting />
          </div>
        </div>

        <div class="tab">
          <label for="tab-2">Store</label>
          <input id="tab-2" name="tabs-two" type="radio" />
          <div class="tab-content">
            <EcommerceStoreInventory />
          </div>
        </div>
      </div>

      <div class="row" v-if="false">
        <div class="column">
          <div class="header">
            <h4>Details</h4>
            <router-link
              :to="{ name: 'EcommerceEdit' }"
              class="whitebutton-gemnote whitebutton-gemnote--tiny"
            >
              <span>Edit</span>
            </router-link>
          </div>

          <div class="row">
            <p class="label">Enabled</p>
            <div class="content disabled">
              <label class="toggle-button">
                <input type="checkbox" :checked="shopDetails.status" />
                <span class="toggle-slider round"></span>
              </label>
            </div>
          </div>

          <div class="row">
            <p class="label">Logo</p>
            <div class="portrait">
              <img :src="logoImage" />
            </div>
          </div>

          <div class="row">
            <p class="label">Banner</p>
            <div class="banner-section">
              <div class="banner-portrait">
                <img :src="bannerImage" />
              </div>
            </div>
          </div>

          <div class="row">
            <p class="label">Primary color</p>
            <div class="content">
              <div class="color-picker-container">
                <span
                  class="primary-color"
                  :style="{
                    backgroundColor: shopDetails.primaryColor
                      ? shopDetails.primaryColor
                      : 'lightgray'
                  }"
                ></span>
              </div>
            </div>
          </div>

          <div class="row">
            <p class="label">Page title</p>
            <div class="content">
              <span>{{ shopDetails.title ? shopDetails.title : '' }}</span>
            </div>
          </div>

          <div class="row">
            <p class="label">Page description</p>
            <div class="content">
              <p class="description">
                {{ shopDetails.description ? shopDetails.description : '' }}
              </p>
            </div>
          </div>

          <div class="row-link ">
            <p class="label">Public link</p>
            <div class="content">
              <div class="link-content">
                <span>
                  {{ shopDetails.storeLink ? shopDetails.storeLink : '' }}
                </span>
                <div>
                  <img src="../../assets/copy-icon.svg" @click="doCopy" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { defaultNotFoundImage, progressStatus } from '@/helpers'

export default {
  name: 'EcommerceDetails',
  components: {
    StoreSetting: () => import('@/components/ECommerce/StoreSetting'),
    EcommerceStoreInventory: () =>
      import('@/components/ECommerce/EcommerceStoreInventory')
  },
  created() {
    this.$store.dispatch('ecommerce/getStoreDetails')
  },
  data() {
    return {
      noImage: defaultNotFoundImage
    }
  },
  methods: {
    doCopy() {
      this.$copyText(this.shopDetails.storeLink).then(
        () => {
          this.$store.dispatch('notification/pushNotification', {
            type: 'success',
            messages: [`Store link copied`]
          })
        },
        error => {
          this.$store.dispatch('notification/pushNotification', {
            type: 'error',
            messages: [`Can not copy store link.`]
          })
          console.log(error)
        }
      )
    }
  },
  computed: {
    loadStatus() {
      return progressStatus(this.loadShopDetails)
    },
    logoImage() {
      return this.shopDetails.logoImage
        ? this.shopDetails.logoImage.url
        : this.noImage
    },
    bannerImage() {
      return this.shopDetails.bannerImage
        ? this.shopDetails.bannerImage.url
        : this.noImage
    },
    ...mapState({
      loadShopDetails: state => state.ecommerce.loadShopDetails,
      shopDetails: state => state.ecommerce.shopDetails
    })
  }
}
</script>

<style scoped lang="scss">
@import '@/global.scss';

.disabled {
  opacity: 0.6;
  pointer-events: none;
}

.row {
  display: flex;
  height: auto;
  align-items: flex-start;
  gap: 1.5rem;
  margin-bottom: 3rem;
}

.row-link {
  display: flex;
  height: auto;
  align-items: flex-start;
  gap: 1.5rem;
  margin-bottom: 1.5rem;
}

.column {
  flex-basis: 70%;
  padding: 2rem;
  background: $light-grey;
}

.header {
  display: flex;
  gap: 1.5rem;
  align-items: center;
  margin-bottom: 2rem;

  h4 {
    text-align: left;
  }
}

.label {
  text-align: left;
  flex-basis: 25%;
  font-weight: 600;
}

.content {
  flex-basis: 75%;
  text-align: left;
}

.banner-section {
  display: flex;
  align-items: flex-end;
  gap: 1rem;
}

input[type='file'] {
  display: none;
}

.portrait {
  height: 100px;
  width: 100px;
  border: 1px solid $main-4;

  img {
    width: 100%;
    height: 100%;
    max-width: 100px;
    object-fit: cover;
    margin: 0 auto;
  }
}

.banner-portrait {
  height: 100px;
  width: 350px;
  height: 150px;
  border: 1px solid $main-4;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    margin: 0 auto;
  }
}

.primary-color {
  position: absolute;
  height: 22px;
  width: 22px;
  top: 2px;
  left: 2px;
  border: 1px solid $main-4;
  border-radius: 1%;
}

.description {
  text-align: justify;
}

.link-content {
  display: flex;
  justify-content: flex-start;
  width: 100%;

  span {
    border: 1px solid $onyx;
    text-align: justify;
    padding: 0.5rem 0.5rem;
  }

  div {
    min-width: 50px;
    border-top: 1px solid $onyx;
    border-bottom: 1px solid $onyx;
    border-right: 1px solid $onyx;
    display: flex;
    justify-content: center;

    img {
      cursor: pointer;
      width: 1.2rem;
    }
  }
}

@media screen and (max-width: 1100px) and (min-width: 930px) {
  .column {
    flex-basis: 75%;
  }
}

@media screen and (max-width: 929px) and (min-width: 750px) {
  .column {
    flex-basis: 85%;
  }
}

@media screen and (max-width: 749px) and (min-width: 650px) {
  .column {
    flex-basis: 95%;
  }
}

@media screen and (max-width: 649px) and (min-width: 350px) {
  .column {
    flex-basis: 100%;
  }

  .label {
    flex-basis: 35%;
  }

  .content {
    flex-basis: 65%;
  }

  .row-link {
    flex-direction: column;
  }
}
</style>
